var _style, _path, _polygon, _polyline, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _g, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 21",
    style: {
      enableBackground: "new 0 0 20 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000054980315215769316220000008544164105080243869_);}\n\t.st2{fill:url(#SVGID_00000036969177808774915230000011857457186681061548_);}\n\t.st3{fill:url(#SVGID_00000122690774788734500980000018215738338934175916_);}\n\t.st4{fill:url(#SVGID_00000021829997136664759140000015677791670367761316_);}\n\t.st5{fill:url(#SVGID_00000008840812664071869260000011894859390660661671_);}\n\t.st6{fill:url(#SVGID_00000100376563234524301640000015007349460173664144_);}\n\t.st7{fill:url(#SVGID_00000143608940166565916990000017837155367313488556_);}\n\t.st8{fill:url(#SVGID_00000152956401042351344290000012545007016127927432_);}\n\t.st9{fill:url(#SVGID_00000089566259478575631520000009478808222703040700_);}\n\t.st10{fill:url(#SVGID_00000136371891696803076330000016358420773196212407_);}\n\t.st11{fill:url(#SVGID_00000081615546186755238570000014283728897816018583_);}\n\t.st12{fill:url(#SVGID_00000125574357823845189080000016873298985578841478_);}\n\t.st13{fill:url(#SVGID_00000137131962403395674490000004535612058584146355_);}\n\t.st14{fill:url(#SVGID_00000029033119745378725590000004760638655576556161_);}\n\t.st15{fill:url(#SVGID_00000124145047339296270490000011148471417873978261_);}\n\t.st16{fill:url(#SVGID_00000170267031505630246880000002568858490676744327_);}\n\t.st17{fill:url(#SVGID_00000070079582496991224020000007641572452915937958_);}\n\t.st18{fill:#A9D59A;}\n\t.st19{fill:#BEDEB0;}\n\t.st20{fill:url(#SVGID_00000036248223238066632340000016257607996585534127_);}\n\t.st21{fill:url(#SVGID_00000078724005173298404860000012875558357085450899_);}\n\t.st22{fill:url(#SVGID_00000031889215221612672170000008161180586280995714_);}\n\t.st23{fill:url(#SVGID_00000094612679675982881290000002014471775246321295_);}\n\t.st24{fill:url(#SVGID_00000112597826529329550490000000203090751478624385_);}\n\t.st25{fill:url(#SVGID_00000063626107587329664960000014333716233067471276_);}\n\t.st26{fill:none;stroke:#FFFFFF;stroke-width:0.196;stroke-linecap:round;stroke-linejoin:round;}\n\t.st27{fill:none;stroke:#FFFFFF;stroke-width:0.196;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9412,
    y1: 6.6251,
    x2: 8.9412,
    y2: 11.2314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#E67BAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#D073AD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,5.2c0,0-2,2.3-2.2,4l1.9,2.1L10,11L10,5.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147207330698314952370000017804372264013791641_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.5578,
    y1: 4.6436,
    x2: 8.5578,
    y2: 9.1566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3731,
    style: {
      stopColor: "#E67BAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5221,
    style: {
      stopColor: "#DC74AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7761,
    style: {
      stopColor: "#C1609E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8467,
    style: {
      stopColor: "#B85A9A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147207330698314952370000017804372264013791641_)"
    },
    d: "M10,4.6L7.3,7.1L7.1,9l0.3-0.1l0.3,0.3 c0,0,0.1-1,1-2.4S10,5.1,10,5.1L10,4.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140733677960888427650000005290614970566557066_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.6653,
    y1: 7.0168,
    x2: 5.6653,
    y2: 9.4374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F49BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#D073AD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000140733677960888427650000005290614970566557066_)"
    },
    points: "6.4,6.8 4.1,6.3 4.2,6.5 6.6,9.5  7.1,9 7.2,7.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134221602789838711540000010164451680707228551_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.3634,
    y1: 7.3417,
    x2: 5.3634,
    y2: 10.2032
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#E685B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#D073AD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134221602789838711540000010164451680707228551_)"
    },
    points: "6.6,9.5 4.1,6.4 4.1,6.7 5,9.8  5.7,10.2 6.5,9.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116195513048624555140000003116663410049289891_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.3202,
    y1: 7.2793,
    x2: 4.3202,
    y2: 9.7664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#E685B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#D073AD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000116195513048624555140000003116663410049289891_)"
    },
    points: "4.9,9.7 4,6.5 3.9,7.1 3.7,9  4.4,9.5 4.9,9.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159453405460149735670000013906595175083309997_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.6248,
    y1: 9.4129,
    x2: 17.6248,
    y2: 10.522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#FCD7CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F8C4C0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000159453405460149735670000013906595175083309997_)"
    },
    points: "18.8,9.1 16.4,9.1 16.6,10.5  18.9,9.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054948606627288674980000015601440623125963917_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.0659,
    y1: 6.6419,
    x2: 11.0659,
    y2: 11.217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#E67BAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#D073AD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054948606627288674980000015601440623125963917_)"
    },
    d: "M10.1,5.2L10,11l0.2,0.2l1.9-2 c0,0-0.2-1.2-0.6-1.7s-0.7-1.2-0.7-1.2L10.1,5.2L10.1,5.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181780700974165484840000015573688191016972460_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.4612,
    y1: 5.7201,
    x2: 11.4612,
    y2: 9.1527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F49BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#D073AD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000181780700974165484840000015573688191016972460_)"
    },
    points: "10,4.6 10,5.1 10.3,5.4 10.5,5.7  10.7,6 11.2,6.8 11.7,7.6 11.9,8.2 12.1,9 12.2,9.2 12.5,8.8 12.6,8.8 12.8,8.9 12.9,8.9 12.7,7.1 10.2,4.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159440331746259945330000007364945747840234914_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.3307,
    y1: 7.0224,
    x2: 14.3307,
    y2: 9.3793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F49BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#D073AD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000159440331746259945330000007364945747840234914_)"
    },
    points: "15.8,6.3 14.9,6.5 14.3,6.6  12.9,7.1 12.8,7.2 12.8,7.7 12.9,8.3 12.9,8.7 12.9,8.9 12.9,9 13.3,9.4 13.4,9.4 14.4,8.2 15,7.4 15.4,6.9 15.8,6.5 15.9,6.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117669862171690433380000017232995552322490782_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.6638,
    y1: 7.3396,
    x2: 14.6638,
    y2: 10.2177
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F49BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#D073AD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000117669862171690433380000017232995552322490782_)"
    },
    points: "15.9,6.5 14.9,7.6 14.2,8.4  13.7,9.1 13.4,9.4 13.5,9.5 14.2,10.2 15,9.8 15.3,8.8 15.8,6.8 15.9,6.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103243299146971771760000005743568532152052613_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.6886,
    y1: 7.2831,
    x2: 15.6886,
    y2: 9.701
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F49BB8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#D073AD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000103243299146971771760000005743568532152052613_)"
    },
    points: "15.9,6.5 15.6,7.8 15.2,9.3  15.1,9.7 15.3,9.6 16.3,9 16,6.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144332132105329063730000017459305532144973952_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.9712,
    y1: 10.1047,
    x2: 14.9712,
    y2: 13.3266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#FCD7CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F9C3C0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000144332132105329063730000017459305532144973952_)"
    },
    points: "16.3,9.1 14.3,10.3 14.2,10.6  13.4,13.1 13.4,13.3 13.4,13.3 16.6,10.5 16.3,9.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054259728494416599720000014039284089067923348_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.8481,
    y1: 9.6551,
    x2: 17.8481,
    y2: 11.2799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F3B0B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1774,
    style: {
      stopColor: "#F3ACBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    style: {
      stopColor: "#F4A4C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F4A1C1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000054259728494416599720000014039284089067923348_)"
    },
    points: "18.9,9.1 16.7,10.5 16.8,10.6  18.1,11.3 19,9.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080916712761294343420000001298434855750365357_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.7142,
    y1: 11.2387,
    x2: 15.7142,
    y2: 13.3848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F3B0B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1774,
    style: {
      stopColor: "#F3ACBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    style: {
      stopColor: "#F4A4C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F4A1C1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000080916712761294343420000001298434855750365357_)"
    },
    points: "16.6,10.6 15.2,11.8 13.4,13.4  14.1,13.2 15.3,12.9 18,11.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105417066223266494400000013779754671015564684_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.2107,
    y1: 10.0148,
    x2: 13.2107,
    y2: 13.697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F3B0B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1774,
    style: {
      stopColor: "#F3ACBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    style: {
      stopColor: "#F4A4C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F4A1C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105417066223266494400000013779754671015564684_)"
    },
    d: "M12.6,8.9c0,0,0.2,3-0.4,4.4l0.1,0.3 l0,0.1l0.9-0.2l0.6-1.9l0.4-1.3L12.6,8.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154415161771236530590000018330400581506891937_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.4406,
    y1: 9.8979,
    x2: 11.4406,
    y2: 13.2307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F0AFB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F9C7C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154415161771236530590000018330400581506891937_)"
    },
    d: "M12.5,8.9c0,0,0.3,2.9-0.4,4.4l-1.3-1.3 l-0.6-0.6l1.5-1.6L12.5,8.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169517197239022874660000014057808039629504902_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.8515,
    y1: 11.8879,
    x2: 8.8515,
    y2: 14.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FACCC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F0B4B8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000169517197239022874660000014057808039629504902_)"
    },
    points: "9.9,11.2 8.7,12.4 7.8,13.3  7.7,13.6 7.7,13.9 9.9,14.4 10,12.6 10,11.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080183244708672357570000012863228247792892066_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1537,
    y1: 11.8977,
    x2: 11.1537,
    y2: 14.3709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1511,
    style: {
      stopColor: "#FACCC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F0B4B8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000080183244708672357570000012863228247792892066_)"
    },
    points: "10,11.1 11.4,12.6 12.1,13.3  12.2,13.4 12.2,13.6 12.3,13.7 12.3,13.9 10,14.4 10,13.9  "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "9.9,14.4 7.7,14 7.7,14.1 8.4,14.5 10,15.7  "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st18",
    points: "12.2,13.9 10,14.4 10,15.7 11.6,14.6 12.3,14.1 12.3,13.9  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "12.3,14.1 12.3,14.1 10,15.8 9.9,15.7 8,14.3 7.7,14.1 7.4,14.6 7.4,14.8 7.7,15.2 10,16.4  12.3,15.2 12.7,14.7  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "14.5,13.2 12.3,13.8 12.3,14 12.4,14.3 12.7,14.7 15.3,14.4  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "18.1,13.4 17.3,13 15.3,13 14.5,13.2 15.4,14.4 18.4,13.6  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "18.4,13.6 15.4,14.4 15.5,15.5 18.5,13.9  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "15.5,15.5 15.5,14.4 12.8,14.7 12.5,15.1 14.5,15.4  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "7.6,13.8 5.5,13.2 4.7,14.3 4.7,14.4 7.3,14.7 7.4,14.4 7.7,14 7.6,13.8  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "5.3,13.1 4.6,13 2.7,13 1.7,13.6 1.9,13.7 4.6,14.4 5.5,13.1  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "4.5,14.4 1.5,13.6 1.5,14 4.5,15.5 4.6,14.4 4.5,14.4  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "7,14.7 4.7,14.4 4.6,15.5 7.6,15.2 7.5,15.1 7.3,14.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172420406156417707280000012788396751083747496_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.5332,
    y1: 9.9143,
    x2: 8.5332,
    y2: 13.2527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F0AFB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F9C7C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172420406156417707280000012788396751083747496_)"
    },
    d: "M7.4,8.9c0,0-0.2,3.5,0.4,4.4l1.1-1.1 l0.8-0.8l0-0.1l-1.9-2L7.4,8.9L7.4,8.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082349361240784755470000000588830158535439246_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.7945,
    y1: 10.0371,
    x2: 6.7945,
    y2: 13.6971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F3B0B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1774,
    style: {
      stopColor: "#F3ACBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    style: {
      stopColor: "#F4A4C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F4A1C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082349361240784755470000000588830158535439246_)"
    },
    d: "M7.1,9.1l-1.3,1.2l0.5,1.8l0.5,1.4 l0.9,0.3l0.1-0.1l0.1-0.3c0,0-0.7-3.3-0.5-4l0-0.4L7.1,9.1L7.1,9.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025426194144902567670000004287250387577477289_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.0413,
    y1: 10.0917,
    x2: 5.0413,
    y2: 13.4356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#FCD7CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F9C3C0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000025426194144902567670000004287250387577477289_)"
    },
    points: "5.6,10.2 3.7,9 3.4,10.5  6.7,13.5 5.7,10.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082352574571215486110000006245661521144141968_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.3145,
    y1: 9.3574,
    x2: 2.3145,
    y2: 10.4998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#FCD7CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F9C3C0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000082352574571215486110000006245661521144141968_)"
    },
    points: "3.7,9.1 3.4,10.5 1,9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007404602369294942510000000952794987483328689_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.1534,
    y1: 9.6411,
    x2: 2.1534,
    y2: 11.338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F3B0B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1774,
    style: {
      stopColor: "#F3ACBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    style: {
      stopColor: "#F4A4C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F4A1C1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000007404602369294942510000000952794987483328689_)"
    },
    points: "1,9.1 1.9,11.3 3.3,10.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080197062969808986790000004521329019676038031_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2507,
    y1: 11.2391,
    x2: 4.2507,
    y2: 13.363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1229,
    style: {
      stopColor: "#F3B0B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1774,
    style: {
      stopColor: "#F3ACBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    style: {
      stopColor: "#F4A4C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#F4A1C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080197062969808986790000004521329019676038031_)"
    },
    d: "M6.5,13.4l-3.1-2.8L2,11.3 c0,0,2.6,1.5,2.7,1.6c0.1,0,1,0.2,1,0.2L6.5,13.4z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.3,7.2c0,0-0.8-0.5-3.3-0.9L3.7,9L1,9l1,2.3L4.8,13l-2,0.1l-1.2,0.6l0,0.4l3,1.6l3.1-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M10,5.1c0,0-1.9,2.2-2.2,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.3,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.8,13.3c0,0-0.2,0.1-0.1,0.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "7.6,13.8 5.5,13.1 4.8,13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "4.6,15.6 4.6,14.4 5.5,13.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "7.7,14.1 7.3,14.7 4.6,14.4 1.6,13.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 7.3,
    y1: 14.7,
    x2: 7.7,
    y2: 15.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "7.4,8.7 5.8,10.3 3.7,9 3.4,10.5 1.9,11.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.4,8.7c0,0-0.3,2.9,0.4,4.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "5.8,10.3 6.7,13.5 3.4,10.5 1,9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.3,7.2c0,0-0.2,1.7-0.1,1.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "5,9.8 4,6.2 6.6,9.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.3,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M9.9,11l-2.1,2.3c0,0-0.2,0.1-0.1,0.8l2.3,1.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "7.7,13.8 5.5,13.1 4.8,13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "4.6,15.6 4.6,14.4 5.5,13.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "7.7,14.1 7.3,14.7 4.6,14.4 1.6,13.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 7.3,
    y1: 14.7,
    x2: 7.7,
    y2: 15.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "9.7,11.3 7.4,8.7 5.8,10.3 3.7,9 3.4,10.5 1.9,11.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.4,8.7c0,0-0.3,2.9,0.4,4.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "5.8,10.3 6.7,13.5 3.4,10.5 1,9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M7.3,7.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 5,
    y1: 9.8,
    x2: 4,
    y2: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M12.7,7.2c0,0,0.8-0.5,3.3-0.9L16.3,9L19,9l-1,2.3L15.2,13l2,0.1l1.2,0.6l0,0.4l-3,1.6l-3.1-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M10,5.1c0,0,1.9,2.2,2.1,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M12.7,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M10,11l2.2,2.3c0,0,0.2,0.1,0.1,0.8L10,15.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "12.4,13.8 14.5,13.1 15.2,13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "15.4,15.6 15.4,14.4 14.5,13.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "12.3,14.1 12.7,14.7 15.4,14.4 18.4,13.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 12.7,
    y1: 14.7,
    x2: 12.3,
    y2: 15.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "10.3,11.3 12.6,8.7 14.2,10.3 16.3,9 16.6,10.5 18.1,11.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M12.6,8.7c0,0,0.3,2.9-0.4,4.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "14.2,10.3 13.3,13.5 16.6,10.5 19,9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M12.7,7.2c0,0,0.2,1.7,0.1,1.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "15,9.8 16,6.2 13.3,9.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M10,16.4l2.3-1.2l3.1,0.4l3-1.6l0-0.4L17.3,13l-2-0.1l2.8-1.6L19,9l-2.7,0L16,6.2 c-2.5,0.5-3.3,0.9-3.3,0.9C12.5,6.8,10,4.6,10,4.6S7.5,6.8,7.3,7.2c0,0-0.8-0.5-3.3-0.9L3.7,9L1,9l1,2.3L4.8,13l-2,0.1l-1.2,0.6 l0,0.4l3,1.6l3.1-0.4L10,16.4L10,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M12.1,9.2C11.9,7.3,10,5.1,10,5.1l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M12.7,7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M12.3,14.1c0-0.6-0.1-0.8-0.1-0.8L10,11l0-5.9V4.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "12.3,13.8 14.5,13.1 15.2,13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "15.4,15.6 15.4,14.4 14.5,13.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "12.3,14.1 12.7,14.7 15.4,14.4 18.4,13.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 12.7,
    y1: 14.7,
    x2: 12.3,
    y2: 15.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "10.3,11.3 12.6,8.7 14.2,10.3 16.3,9 16.6,10.5 18.1,11.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M12.6,8.7c0,0,0.3,2.9-0.4,4.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st26",
    points: "14.2,10.3 13.3,13.5 16.6,10.5 19,9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M12.7,7.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 15,
    y1: 9.8,
    x2: 16,
    y2: 6.2
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st27",
    points: "7.7,13.9 10,14.4 12.3,13.9  "
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st27",
    points: "10,11 10,14.4 10,15.8  "
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st26",
    x1: 10,
    y1: 15.7,
    x2: 10,
    y2: 16.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDapp);
export default __webpack_public_path__ + "static/media/dapp.8f7d67a34958d5fec6a024bda920fabc.svg";
export { ForwardRef as ReactComponent };